import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronForward = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" })
});
export default SvgChevronForward;
